import RightArrowIcon from "@imgs/arrow.svg?react";
import { ICellRendererParams } from "ag-grid-community";
import { Button } from "antd";
import classNames from "classnames";
import { AgRowNodeEventListener } from "node_modules/ag-grid-community/dist/types/core/interfaces/iRowNode";
import { ExpandedChangedEvent } from "node_modules/ag-grid-enterprise/dist/types/enterprise-core/widgets/agGroupComponent";

import { ReactNode, useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";

type LinkColumnProps<TData> = {
  row: ICellRendererParams<TData, string>;
  isLink?: boolean;
  getLink: (data: TData | undefined) => string;
  children?: ReactNode;
  rowExpand?: boolean;
  onLinkButtonClick?: () => void;
};

export default function LinkColumn<TData>({
  row,
  children,
  getLink,
  isLink = true,
  rowExpand = true,
  onLinkButtonClick,
}: LinkColumnProps<TData>) {
  const { node, value, data } = row;
  const [expanded, setExpanded] = useState(node.expanded);

  useEffect(() => {
    const expandListener: AgRowNodeEventListener<ExpandedChangedEvent> = (
      event,
    ) => setExpanded(event.node.expanded);
    node.addEventListener("expandedChanged", expandListener);
    return () => {
      node.removeEventListener("expandedChanged", expandListener);
    };
  }, [node]);

  const onClick = useCallback(() => node.setExpanded(!node.expanded), [node]);

  return (
    <div className="flex items-center gap-1">
      {rowExpand && (
        <div
          className="w-5 h-5 p-1 rounded hover:bg-slate-300 cursor-pointer flex
        items-center justify-center"
          onClick={onClick}
        >
          <RightArrowIcon
            className={classNames(
              "transition duration-500",
              expanded ? "rotate-90" : "rotate-0",
            )}
          />
        </div>
      )}
      {isLink ? (
        <Link to={getLink(data)}>
          <Button className="!px-0" type="link" onClick={onLinkButtonClick}>
            <span className="select-text" title={value as string}>
              {value}
            </span>
          </Button>
        </Link>
      ) : (
        <Button className="!px-0" type="link" onClick={onLinkButtonClick}>
          <span className="select-text" title={value as string}>
            {value}
          </span>
        </Button>
      )}
      {/* </Link> */}
      {children}
    </div>
  );
}
